import React, { useRef, useState, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { customWidgetEndpointLayers, customWidgetEndpoints } from '../../../config/widgetEndpoints';
import { customEnergySummaryChartFilterButtons } from '../../../config/chartFilterButtons';
import MachineLayoutComponent from '../../machinedetail/components/machinelayout.component';
import useHttpApiCall from '../../../services/useHttpApiCall';
import RefreshOnceTotalEnergyUse from '../../../common/chartautorefresh/refresh.once.total.enery.use';
import MainTotalEnergyUseContainer from '../../../common/layout/containers/main.total.energy.use.container';
import DateRangeSet from '../../../common/datetimepicker/daterangeset';

export default function CustomTotalEnergyUseContainer(props) {
  //console.log("Summary",props)
  const INITIALFILTER = '1day';
  const [initialFilter, setInitialFilter] = useState('1day');
  const charRef = useRef(undefined);
  const [chartApiData, setChartApiData] = useState([]);
  const [chartApiData2, setChartApiData2] = useState([]);
  const [payload, setPayload] = useState(undefined);
  const [graphFilter, setGraphFilter] = useState({
    filterMain: INITIALFILTER
  });
  const [filterByDateCheck, setFilterByDateCheck] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [apiDateRange, setApiDateRange] = useState([]);
  const comparisonFilter = useSelector((state) => state.comparisonFilter.set_comparison_filter);
  const [apiParams, setApiParams] = useState(null);
  const [comparisonViewCheck, setComparisonViewCheck] = useState(false);
  const [config, setConfig] = useState({});
  const graphFilterObject = customEnergySummaryChartFilterButtons;
  const [data, loading, error] = useHttpApiCall(payload);
  const [togglePriceCheck, setTogglePriceCheck] = useState(false);
  const [daySummaryDrilldownDate, setDaySummaryDrilldownDate] = useState(null);
  const flexibleEquipmentEnabled=localStorage.getItem('flexible_equipment')=='true'?true:false

  const graphInfo = {
    isSummaryGraph: true
  }
  const graphApiCall = () => {
    if (
      (graphFilter.filterMain == '1week' || graphFilter.filterMain == '1month') &&
      daySummaryDrilldownDate
    ) {
      setPayload({
        auth: true,
        url: flexibleEquipmentEnabled?customWidgetEndpointLayers.energyUseSummary:customWidgetEndpoints.energyUseSummary,
        params: {
          ...apiParams,
          duration: graphFilterObject[graphFilter.filterMain].drilldown,
          summary_date: daySummaryDrilldownDate
        }
      });
      charRef.current.chart.showLoading();
    } 
    else if(apiParams?.end_date_time && apiParams?.start_date_time ){
      const filterDateRange = { start_date_time: apiDateRange[0], end_date_time: apiDateRange[1] }
      setPayload({
        auth: true,
        url: flexibleEquipmentEnabled ? customWidgetEndpointLayers.energyUseSummary : customWidgetEndpoints.energyUseSummary,
        params: flexibleEquipmentEnabled ?daySummaryDrilldownDate? {
          layer_type: props?.graphInfo?.layer_type,
          plant_code: props?.plant_code,
          layer_id: props?.graphInfo?.layer_id,
          duration: '1day',
          summary_date: daySummaryDrilldownDate
        }:{
          layer_type: props?.graphInfo?.layer_type,
          plant_code: props?.plant_code,
          layer_id: props?.graphInfo?.layer_id,
          ...filterDateRange
        } : {
          process_id: apiParams?.process_id,
          sub_process_id: apiParams?.sub_process_id,
          equipment_id: apiParams?.equipment_id,
          duration: '1day',
          summary_date: daySummaryDrilldownDate
        }
      });
    }
    else {
      //Main view
      setPayload({
        auth: true,
        url: flexibleEquipmentEnabled?customWidgetEndpointLayers.energyUseSummary:customWidgetEndpoints.energyUseSummary,
        params: apiParams
      });
    }
  };

  const unsetInnerDrilldown = () => {
    setDaySummaryDrilldownDate(null);
  };

  return (
    <div>
      <Suspense fallback={<span>Loadiing</span>}>
        <DateRangeSet
          graphFilter={graphFilter}
          setFilterByDateCheck={setFilterByDateCheck}
          filterByDateCheck={filterByDateCheck}
          dateRange={dateRange}
          setDateRange={setDateRange}
          setGraphFilter={setGraphFilter}
          INITIALFILTER={INITIALFILTER}
          setApiDateRange={setApiDateRange}
          graphInfo={graphInfo}

        />
        <RefreshOnceTotalEnergyUse
          graphApiCall={graphApiCall}
          data={data}
          loading={loading}
          error={error}
          comparisonViewCheck={comparisonViewCheck}
          comparisonFilter={comparisonFilter}
          graphFilter={graphFilter}
        />
        <MainTotalEnergyUseContainer
          initialFilter={initialFilter}
          setInitialFilter={setInitialFilter}
          togglePriceCheck={togglePriceCheck}
          setTogglePriceCheck={setTogglePriceCheck}
          comparisonViewCheck={comparisonViewCheck}
          data={data}
          charRef={charRef}
          setGraphFilter={setGraphFilter}
          setConfig={setConfig}
          chartApiData={chartApiData}
          chartApiData2={chartApiData2}
          config={config}
          setFilterByDateCheck={setFilterByDateCheck}
          apiDateRange={apiDateRange}
          apiParams={apiParams}
          setApiParams={setApiParams}
          props={props}
          graphFilter={graphFilter}
          graphApiCall={graphApiCall}
          INITIALFILTER={INITIALFILTER}
          filterByDateCheck={filterByDateCheck}
          setChartApiData={setChartApiData}
          setChartApiData2={setChartApiData2}
          setComparisonViewCheck={setComparisonViewCheck}
          comparisonFilter={comparisonFilter}
          setDaySummaryDrilldownDate={setDaySummaryDrilldownDate}
          daySummaryDrilldownDate={daySummaryDrilldownDate}
          daySummaryDrilldownEnabled={true}
        />
        <MachineLayoutComponent
          chartApiData={chartApiData}
          loading={loading}
          chartData={config}
          charRef={charRef}
          expandWindow={props.expandWindow}
          minimizeWindow={props.minimizeWindow}
          shouldExpand={props.shouldExpand}
          chartId={props.id}
          hasFilter={true}
          graphFilter={graphFilter}
          setGraphFilter={setGraphFilter}
          graphFilterObject={graphFilterObject}
          hasSettings={false}
          filterByDate={true}
          setFilterByDateCheck={setFilterByDateCheck}
          filterByDateCheck={filterByDateCheck}
          dateRange={dateRange}
          setDateRange={setDateRange}
          hasIncompletePeriodLegend={true}
          comparisonView={true}
          comparisonViewCheck={comparisonViewCheck}
          setComparisonViewCheck={setComparisonViewCheck}
          daySummaryDrilldownDate={daySummaryDrilldownDate}
          unsetInnerDrilldown={unsetInnerDrilldown}
          graphInfo={graphInfo}
        />
      </Suspense>
    </div>
  );
}
